export enum StatsElementInfoType {
  NumIpoText = 'numIpoText',
  ProceedsText = 'proceedsText',
  Footnote = 'footnote',
}
